// extracted by mini-css-extract-plugin
module.exports = {"notification":"a10a3f92e9--notification--JByXO","calendar":"a10a3f92e9--calendar--XJbp6"};